import styled from 'styled-components'

export const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 24px;
`
export const FormHeader = styled.div`
  margin-bottom: 6px;
  display: flex;
  gap: 12px;
  line-height: 1.2;
  color: var(--t-text-secondary);
`

export const HeaderCell = styled.div`
  width: 100%;
  max-width: 294px;

  &:nth-child(3) {
    max-width: 54px;
  }

  &:nth-child(4) {
    max-width: 144px;
  }
`
